import { render } from "./CouchFillter.vue?vue&type=template&id=36e134c4&scoped=true"
import script from "./CouchFillter.vue?vue&type=script&lang=js"
export * from "./CouchFillter.vue?vue&type=script&lang=js"

import "./CouchFillter.vue?vue&type=style&index=0&id=36e134c4&scoped=true&lang=css"

import exportComponent from "/home/hiba/project03-vue.js-find-a-coach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e134c4"]])

export default __exports__